export default __webpack_public_path__ + "static/media/IMG-20210326-WA0050.021dd7f5.jpg";